module.exports = __webpack_public_path__ + "img/oculus_user_journeymap.06c401dc.png";